<template>
  <div class="water">
    <div class="zhiwei">
      <div class="title">
        <titleCard title='Intelligent Maintenance — Dialysis Water Treatment System'></titleCard>
      </div>
      <div class="content">
        <div class="left animate__animated wow animate__fadeInLeft">
          The integration of advanced technologies such as the IoT and cloud computing enables automatic transmission of work data, effectively improving the safety and quality of dialysis, as well as the quality control of the department, and strengthening the awareness of responsibility of the staff.</div>
        <div class="right animate__animated wow animate__fadeInRight">
          <img src="../../assets/image/News/shuiji/shuiji1.webp" alt="">
        </div>
      </div>
      <!-- 核心功能 -->
      <div class="hexin">
        <div class="title">
          <titleCard title="Core Functions"></titleCard>
        </div>
        <p class="titletxt">Efficient information transfer Quality equipment after-sales service<br>Quality customer service</p>
        <div class="myboxs">
          <div class="mybox">
            <div class="pic animate__animated wow animate__fadeInLeft"><img
                src="../../assets/image/News/shuiji/shuiji2.webp" alt=""></div>
            <div class="txt animate__animated wow animate__fadeInRight">
              <img src="../../assets/image/News/shuiji/icon3.png" alt="">
              <h3>Automatic Acquisition</h3>
              <p>real-time working data of the water machine.</p>
            </div>
          </div>
          <div class="mybox">
            <div class="txt txt2 animate__animated wow animate__fadeInLeft">
              <img src="../../assets/image/News/shuiji/icon1.webp" alt="">
              <h3>Intelligent Warning</h3>
              <p>guarantee time, renewal of supplies, <br>critical timepoints, automatic pre-alerts, etc.</p>
            </div>
            <div class="pic animate__animated wow animate__fadeInRight"><img
                src="../../assets/image/News/shuiji/shuiji3.webp" alt=""></div>
          </div>
          <div class="mybox">
            <div class="pic animate__animated wow animate__fadeInLeft"><img
                src="../../assets/image/News/shuiji/shuiji4.webp" alt=""></div>
            <div class="txt txt2 animate__animated wow animate__fadeInRight">
              <img src="../../assets/image/News/shuiji/icon4.png" alt="">
              <h3>Scan QR code if Malfunction</h3>
              <p>WeChat scan, simple and convenient</p>
            </div>
          </div>
          <div class="mybox">
            <div class="txt txt2 animate__animated wow animate__fadeInLeft">
              <img src="../../assets/image/News/shuiji/icon5.png" alt="">
              <h3>Statistical Analysis</h3>
              <p>multi-dimensional data analysis to improve product quality and management</p>
            </div>
            <div class="pic animate__animated wow animate__fadeInRight"><img
                src="../../assets/image/News/shuiji/shuiji5.webp" alt=""></div>
          </div>
          <div class="mybox">
            <div class="pic animate__animated wow animate__fadeInLeft"><img
                src="../../assets/image/News/shuiji/shuiji6.webp" alt=""></div>
            <div class="txt txt2 animate__animated wow animate__fadeInRight">
              <img src="../../assets/image/News/shuiji/icon6.png" alt="">
              <h3>Daily Records</h3>
              <p>electronic work record, exportable printable form</p>
            </div>
          </div>
          <div class="mybox">
            <div class="txt txt2 animate__animated wow animate__fadeInLeft">
              <img src="../../assets/image/News/shuiji/icon7.png" alt="">
              <h3>Product Lifecycle Management</h3>
              <p>traceable history of equipment installation, <br>repair and maintenance</p>
            </div>
            <div class="pic animate__animated wow animate__fadeInRight"><img
                src="../../assets/image/News/shuiji/shuiji7.webp" alt=""></div>
          </div>
        </div>
        <div class="myiosboxs">
          <div class="mybox">
            <div class="pic animate__animated wow animate__fadeInUp"><img
                src="../../assets/image/News/shuiji/shuiji2.webp" alt=""></div>
            <div class="txt animate__animated wow animate__fadeInUp">
              <img src="../../assets/image/News/shuiji/icon3.png" alt="">
              <div class="text">
                <h3>Automatic Acquisition</h3>
                <p>real-time working data of the water machine.</p>
              </div>
            </div>
          </div>
          <div class="mybox">
            <div class="pic animate__animated wow animate__fadeInUp"><img
                src="../../assets/image/News/shuiji/shuiji3.webp" alt=""></div>
            <div class="txt animate__animated wow animate__fadeInUp">
              <img src="../../assets/image/News/shuiji/icon1.webp" alt="">
              <div class="text">
                <h3>Intelligent Warning</h3>
                <p>guarantee time, renewal of supplies, critical timepoints, automatic pre-alerts, etc.</p>
              </div>
            </div>
          </div>
          <div class="mybox">
            <div class="pic animate__animated wow animate__fadeInUp"><img
                src="../../assets/image/News/shuiji/shuiji4.webp" alt=""></div>
            <div class="txt animate__animated wow animate__fadeInUp">
              <img src="../../assets/image/News/shuiji/icon4.png" alt="">
              <div class="text">
                <h3>Scan QR code if Malfunction</h3>
                <p>WeChat scan, simple and convenient</p>
              </div>
            </div>
          </div>
          <div class="mybox">
            <div class="pic animate__animated wow animate__fadeInUp"><img
                src="../../assets/image/News/shuiji/shuiji5.webp" alt=""></div>
            <div class="txt animate__animated wow animate__fadeInUp">
              <img src="../../assets/image/News/shuiji/icon5.png" alt="">
              <div class="text">
                <h3>Statistical Analysis</h3>
                <p>multi-dimensional data analysis to improve product quality and management</p>
              </div>
            </div>
          </div>
          <div class="mybox">
            <div class="pic animate__animated wow animate__fadeInUp"><img
                src="../../assets/image/News/shuiji/shuiji6.webp" alt=""></div>
            <div class="txt animate__animated wow animate__fadeInUp">
              <img src="../../assets/image/News/shuiji/icon6.png" alt="">
              <div class="text">
                <h3>Daily Records</h3>
                <p>electronic work record, exportable printable form</p>
              </div>
            </div>
          </div>
          <div class="mybox">
            <div class="pic animate__animated wow animate__fadeInUp"><img
                src="../../assets/image/News/shuiji/shuiji7.webp" alt=""></div>
            <div class="txt animate__animated wow animate__fadeInUp">
              <img src="../../assets/image/News/shuiji/icon7.png" alt="">
              <div class="text">
                <h3>Product Lifecycle Management</h3>
                <p>traceable history of equipment installation, repair and maintenance</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <footerCard name='Mr Lin' phone='135-2227-8747'></footerCard>
  </div>
</template>

<script>
import footerCard from '../../components/footer-card2.vue'
import titleCard from '../../components/title-card.vue'
export default {
  data() {
    return {

    }
  },
  components: {
    footerCard,
    titleCard
  },
  created() {

  },
  mounted() {

  },
  methods: {
  }
}
</script>

<style scoped lang="scss">
.water {
  .zhiwei {
    .title {
      padding: 1rem 0 1.4316rem 0;
      @media screen and (max-width: 540px) {
        padding: 37px 0 54px 0;
      }
    }
    .content {
      height: 5.2632rem;
      display: flex;
      align-items: center;
      margin-bottom: 2.2632rem;
      @media screen and (max-width: 540px) {
        display: block;
        height: 100%;
      }
      .left {
        width: 7.2211rem;
        margin-right: 1.6842rem;
        margin-left: 2.3158rem;
        color: #272b2d;
        line-height: 0.4421rem;
        font-size: 0.2526rem;
        @media screen and (max-width: 540px) {
          width: 100%;
          box-sizing: border-box;
          padding: 0 26px;
          margin: 0;
          color: #272b2d;
          font-size: 15px;
          line-height: 26px;
        }
      }
      .right {
        width: 7rem;
        @media screen and (max-width: 540px) {
          width: 100%;
          box-sizing: border-box;
          padding: 0 26px;
          margin: 0;
          height: 280px;
          margin-top: 20px;
        }
        img {
          width: 100%;
          height: 100%;
        }
      }
    }
    .hexin {
      .title {
        padding-bottom: 0.5263rem;
      }
      .titletxt {
        color: #666666;
        text-align: center;
        font-size: 0.2526rem;
        line-height: 0.4211rem;
        padding-bottom: 2.1053rem;
        @media screen and (max-width: 540px) {
          color: #666666;
          font-size: 15px;
          line-height: 25px;
        }
      }
      .myboxs {
        @media screen and (max-width: 540px) {
          display: none;
        }
        .mybox {
          display: flex;
          padding: 0 1.6842rem;
          align-items: center;
          justify-content: center;
          margin-bottom: 1.0526rem;
          .pic {
            width: 50%;
            height: 5.2632rem;
            img {
              width: 100%;
              height: 100%;
            }
          }
          .txt {
            padding-left: 1.1158rem;
            box-sizing: border-box;
            width: 50%;
            img {
              display: block;
              width: 0.5053rem;
              height: 0.4737rem;
            }
            h3 {
              margin: 0;
              padding: 0.3263rem 0 0.4211rem 0;
              color: #333333;
              font-size: 0.2947rem;
            }
            p {
              font-size: 0.2526rem;
              color: #333333;
              line-height: 0.4211rem;
            }
          }
          .txt2 {
            padding-left: 2.1053rem;
          }
        }
      }
      .myiosboxs {
        display: none;
        @media screen and (max-width: 540px) {
          display: block;
        }
        margin-bottom: 150px;
        .mybox {
          padding: 0 14px;
          align-items: center;
          justify-content: center;
          margin-bottom: 36px;
          .pic {
            width: 100%;
            height: 215px;
            margin-bottom: 23px;
            img {
              width: 100%;
              height: 100%;
            }
          }
          .txt {
            padding-left: 5px;
            box-sizing: border-box;
            width: 100%;
            display: flex;
            align-items: center;
            img {
              display: block;
              width: 30px;
              height: 28px;
              padding-right: 18px;
            }
            .text {
              h3 {
                margin: 0;
                padding: 0.3263rem 0 0.4211rem 0;
                color: #333333;
                font-size: 17px;
              }
              p {
                font-size: 15px;
                color: #333333;
                padding-right: 50px;
                line-height: 25px;
              }
            }
          }
          .txt2 {
            padding-left: 2.1053rem;
          }
        }
      }
    }
  }
}
</style>
